import React from 'react';
import { Radio } from '@cowsquare/design';
import * as R from 'ramda';

export const FilterTags = ({ value, tags, onChange }) => (
  <Radio.Group onChange={onChange} value={value}>
    {R.map(
      tag => (
        <Radio.Tag key={tag} value={tag}>
          {tag}
        </Radio.Tag>
      ),
      tags
    )}
  </Radio.Group>
);
